import {
  getNotificationMeta,
  formatRelativeTime,
} from "@/lib/notificationRoutes";

export default function NotificationItem({ notification, onClick, compact = false }) {
  const meta = getNotificationMeta(notification.type, notification.message);
  const Icon = meta.icon;

  return (
    <button
      type="button"
      onClick={() => onClick(notification)}
      className={`w-full text-left px-3 ${compact ? "py-2.5" : "py-3"} border-b border-slate-50 hover:bg-slate-50 transition-colors group ${
        !notification.is_read ? "bg-blue-50/60" : ""
      }`}
    >
      <div className="flex items-start gap-3">
        <div className={`mt-0.5 h-9 w-9 rounded-xl flex items-center justify-center shrink-0 ${meta.color}`}>
          <Icon className="w-4 h-4" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <p className={`text-sm truncate ${!notification.is_read ? "font-semibold text-slate-900" : "font-medium text-slate-800"}`}>
              {notification.title}
            </p>
            {!notification.is_read && (
              <span className="h-2 w-2 rounded-full bg-blue-500 shrink-0" />
            )}
          </div>
          <p className="text-xs text-slate-500 mt-0.5 line-clamp-2 leading-relaxed">{notification.message}</p>
          <div className="flex items-center gap-2 mt-1.5">
            <span className="text-[10px] font-medium text-slate-400 uppercase tracking-wide">
              {meta.label}
            </span>
            <span className="text-[10px] text-slate-300">·</span>
            <span className="text-[10px] text-slate-400">
              {formatRelativeTime(notification.created_at)}
            </span>
          </div>
        </div>
      </div>
    </button>
  );
}